// extracted by mini-css-extract-plugin
module.exports = {"row":"WaitingNoteRow_row__NwwmI","text":"WaitingNoteRow_text__h4wEX","chevron":"WaitingNoteRow_chevron__ZnhKA","wrap":"WaitingNoteRow_wrap__es5zl"};